// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__2GgdU","overlayIsClosed":"Overlay_overlayIsClosed__2GSGb","overlayContent":"Overlay_overlayContent__3bvgK","list":"Overlay_list__3OZE8"};